import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthService } from './shared/services';
import { LoaderService } from './shared/services/loader.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthUserService } from './shared/services/AuthUser.service';
import { LocalizationService } from './shared/services/localization.service';
import { getVersionDisplay, isTestEnvironment } from './shared/utils/version-display';

declare const require: any; // 版本資訊

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ AuthUserService ]
})
export class AppComponent implements OnInit {  
  public version: string = getVersionDisplay(require('../../package.json').version); // 版本資訊;
  public isTestVersion: boolean = isTestEnvironment();
  isLoadingResults = false;
  title: string = '天然災害法親關懷';


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  
  constructor(private breakpointObserver: BreakpointObserver,
    private loaderService: LoaderService,
    private localizationService: LocalizationService,
    public authService: AuthService,
    public authUsersService: AuthUserService) {
  }

  ngOnInit() {
    this.loaderService.loaderStatus.subscribe(result => {
      this.isLoadingResults = result;
    });
    
  }
}
